import React from "react";
import { Grid2, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import MessageIcon from "@mui/icons-material/Message";
import DescriptionIcon from "@mui/icons-material/Description";
import { SECTION_LABELS, N_A } from "../AppointmentDetailsModal.constants";
import {
  StyledSectionHeader,
  StyledSectionTitle,
  StyledInfoCard,
  StyledLabelValueRow,
  StyledLabel,
  StyledValue,
  StyledIconWrap,
  StyledSectionIconWrap,
} from "../AppointmentDetailsModal.styles";
import AppointmentDetailsModalClientInfoField from "./AppointmentDetailsModalClientInfoField";

const AppointmentDetailsModalClientInformationSection = ({
  appointment,
  practitionerName,
  isPractitioner,
  agreementSigned = true,
  telehealthConsentSigned = true,
}) => {
  const contactName = appointment?.contact?.name || appointment?.title || N_A;
  const sectionTitle = isPractitioner
    ? SECTION_LABELS.CLIENT_INFO
    : SECTION_LABELS.YOUR_INFO;

  return (
    <Grid2 item size={{ xs: 12 }}>
      <StyledSectionHeader>
        <StyledSectionIconWrap>
          <PersonIcon />
        </StyledSectionIconWrap>
        <StyledSectionTitle>{sectionTitle}</StyledSectionTitle>
      </StyledSectionHeader>
      <StyledInfoCard>
        <Grid2 container spacing={2}>
          <AppointmentDetailsModalClientInfoField
            icon={BadgeIcon}
            label={SECTION_LABELS.NAME}
            value={contactName}
            valueVariant="body1"
          />
          {appointment.contact?.email && (
            <AppointmentDetailsModalClientInfoField
              icon={EmailIcon}
              label={SECTION_LABELS.EMAIL}
              value={appointment.contact.email}
            />
          )}
          {appointment.contact?.phone && (
            <AppointmentDetailsModalClientInfoField
              icon={PhoneIcon}
              label={SECTION_LABELS.PHONE}
              value={appointment.contact.phone}
            />
          )}
          {practitionerName && (
            <AppointmentDetailsModalClientInfoField
              icon={PersonIcon}
              label={SECTION_LABELS.PRACTITIONER}
              value={practitionerName}
            />
          )}
          {isPractitioner && (
            <Grid2 item size={{ xs: 12, sm: 6 }}>
              <StyledLabelValueRow>
                <StyledIconWrap>
                  <DescriptionIcon />
                </StyledIconWrap>
                <StyledLabel>Agreement</StyledLabel>
              </StyledLabelValueRow>
              <StyledValue style={{ marginLeft: 28 }}>
                <Chip
                  label={
                    agreementSigned === undefined
                      ? "Checking..."
                      : agreementSigned
                        ? "Signed"
                        : "Not Signed"
                  }
                  size="small"
                  sx={{
                    fontWeight: 600,
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "0.75rem",
                    backgroundColor:
                      agreementSigned === undefined
                        ? "#9E9E9E"
                        : agreementSigned
                          ? "#4CAF50"
                          : "#FF9800",
                    color: "white",
                  }}
                />
              </StyledValue>
            </Grid2>
          )}
          {isPractitioner && (
            <Grid2 item size={{ xs: 12, sm: 6 }}>
              <StyledLabelValueRow>
                <StyledIconWrap>
                  <DescriptionIcon />
                </StyledIconWrap>
                <StyledLabel>Telehealth Consent</StyledLabel>
              </StyledLabelValueRow>
              <StyledValue style={{ marginLeft: 28 }}>
                <Chip
                  label={
                    telehealthConsentSigned === undefined
                      ? "Checking..."
                      : telehealthConsentSigned
                        ? "Signed"
                        : "Not Signed"
                  }
                  size="small"
                  sx={{
                    fontWeight: 600,
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "0.75rem",
                    backgroundColor:
                      telehealthConsentSigned === undefined
                        ? "#9E9E9E"
                        : telehealthConsentSigned
                          ? "#4CAF50"
                          : "#FF9800",
                    color: "white",
                  }}
                />
              </StyledValue>
            </Grid2>
          )}
          {appointment.description && (
            <AppointmentDetailsModalClientInfoField
              icon={MessageIcon}
              label={SECTION_LABELS.MESSAGE}
              value={appointment.description}
            />
          )}
        </Grid2>
      </StyledInfoCard>
    </Grid2>
  );
};

export default AppointmentDetailsModalClientInformationSection;
